var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.674,0A15.674,15.674,0,1,0,31.349,15.674,15.674,15.674,0,0,0,15.674,0Zm7.872,12.7c.007.162.011.325.011.488A10.747,10.747,0,0,1,7.014,22.245a7.694,7.694,0,0,0,.9.052,7.582,7.582,0,0,0,4.693-1.618,3.783,3.783,0,0,1-3.53-2.624,3.772,3.772,0,0,0,1.706-.065,3.78,3.78,0,0,1-3.032-3.7c0-.017,0-.032,0-.048a3.751,3.751,0,0,0,1.711.473A3.782,3.782,0,0,1,8.3,9.666a10.728,10.728,0,0,0,7.789,3.948,3.781,3.781,0,0,1,6.439-3.446,7.572,7.572,0,0,0,2.4-.917,3.792,3.792,0,0,1-1.662,2.09,7.543,7.543,0,0,0,2.17-.595A7.688,7.688,0,0,1,23.547,12.7Z","fill":"#ebebed"}));
}

Twitter.defaultProps = {"width":"31.349","height":"31.349","viewBox":"0 0 31.349 31.349"};

module.exports = Twitter;

Twitter.default = Twitter;
